'use client';
import Accordion from '@ui/Accordion';

import { cn } from '@util/index';
import { Roboto } from 'next/font/google';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { Question } from './giveaway-questions';

const roboto = Roboto({
  subsets: ['latin'],
});

export const GiveawayFAQ = ({
  questions,
  initialValue = 'How do I enter the giveaway?',
  titleClassName,
  title = 'Frequently Asked Questions',
  textClassName,
  useRoboto = false,
}: {
  questions: Question[];
  initialValue?: string;
  titleClassName?: string;
  title?: string;
  textClassName?: string;
  useRoboto?: boolean;
}) => {
  const [currentTopic, setCurrentTopic] = useState<string | undefined>(
    initialValue
  );

  return (
    <div className="mb-16 mt-16 flex w-full flex-col gap-x-24 lg:mx-auto lg:mb-32 lg:mt-0 lg:min-h-[60rem] lg:max-w-default lg:flex-row">
      <div className="flex flex-col justify-between">
        <div className="flex flex-col items-center gap-y-6 lg:items-start">
          <Image
            src="/assets/faq-bubbles.png"
            alt="FAQ"
            width={112}
            height={112}
            className="h-[10rem] w-[10rem]"
          />

          <h3
            className={cn(
              useRoboto && roboto.className,
              useRoboto
                ? 'w-[30rem] text-center text-[3.4rem] font-bold uppercase tracking-tight lg:text-left'
                : 'w-[30rem] text-center text-[3.4rem] font-semibold lg:text-left'
            )}
          >
            {title}
          </h3>
        </div>

        <h3 className="mt-8 text-center text-[1.8rem] lg:mt-0 lg:text-left">
          Still have questions? Feel free to{' '}
          <Link href="/contact" className="font-semibold text-brand-secondary">
            Contact Us
          </Link>
          .
        </h3>
      </div>

      <div className="flex w-auto flex-col gap-[6rem] px-16 pt-16 sm:mt-0 lg:mx-auto lg:w-[90rem] lg:max-w-default lg:px-0 lg:pt-[13rem]">
        <div className="flex flex-col gap-[3.2rem]">
          {questions.map((faq, i) => {
            return (
              <Accordion
                key={`${currentTopic}${faq.q}${i}`}
                title={faq.q}
                divider={true}
                hover="text"
                intent="faq"
                highlightHeaderOnOpen={true}
                startOpen={currentTopic === faq.q}
                onOpen={() => setCurrentTopic(faq.q)}
                onClose={() => setCurrentTopic(undefined)}
                titleClassName={titleClassName}
              >
                <div className={`pl-[1.6rem] ${textClassName}`}>{faq.a}</div>
              </Accordion>
            );
          })}
        </div>
      </div>
    </div>
  );
};
